/* eslint-disable sonarjs/no-duplicate-string */
const translations = {
  pt: {
    title: 'Habilidades',
    subTitle: 'Stack que uso no trabalho',
  },
  en: {
    title: 'Skills',
    subTitle: 'Stack I use on the job',
  },
  screenSkills: [
    {
      image: '/frontend.svg',
      titlePT: 'Frontend',
      titleEN: 'Frontend',
      descriptionPT:
        'Telas e fluxos que o usuário percorre de verdade: componentes reutilizáveis, estado legível e atenção a lista grande e rede lenta. Trabalhei com Next.js, React e Angular dependendo do produto.',
      descriptionEN:
        'Real product UI: reusable pieces, state you can reason about, and care for slow networks and heavy lists. I have shipped with Next.js, React, and Angular depending on the team.',
      languagesTitlePT: 'Linguagens',
      languagesTitleEN: 'Languages',
      languages: ['TypeScript', 'JavaScript'],
      toolsTitlePT: 'Frameworks e ferramentas',
      toolsTitleEN: 'Frameworks & tools',
      tools: [
        { pt: 'Next.js', en: 'Next.js' },
        { pt: 'React', en: 'React' },
        { pt: 'Angular', en: 'Angular' },
        { pt: 'Tailwind CSS', en: 'Tailwind CSS' },
        { pt: 'Redux', en: 'Redux' },
        { pt: 'Integração REST', en: 'REST integration' },
      ],
    },
    {
      image: '/backend.svg',
      titlePT: 'Backend e APIs',
      titleEN: 'Backend & APIs',
      descriptionPT:
        'Serviços e APIs estáveis em Node.js (NestJS ou Express quando o projeto pede); também trabalho em Python, Go e Java quando a stack ou o produto assim exige. Validação na borda, log e métricas para achar falha em integração ou fila sem adivinhar.',
      descriptionEN:
        'Stable services and APIs in Node.js (NestJS or Express as the codebase dictates); Python, Go, and Java when the stack or product calls for them. Validation at the edge, logs/metrics so integration or queue failures show up fast.',
      languagesTitlePT: 'Runtime e linguagens',
      languagesTitleEN: 'Runtime & languages',
      languages: ['Node.js', 'TypeScript', 'JavaScript', 'Python', 'Golang', 'Java'],
      toolsTitlePT: 'Frameworks e contratos',
      toolsTitleEN: 'Frameworks & contracts',
      tools: [
        { pt: 'NestJS', en: 'NestJS' },
        { pt: 'Express', en: 'Express' },
        { pt: 'REST APIs', en: 'REST APIs' },
        { pt: 'GraphQL', en: 'GraphQL' },
        { pt: 'Webhooks', en: 'Webhooks' },
        {
          pt: 'APIs externas (pagamentos, mensageria, integrações estilo ERP)',
          en: 'External APIs (payments, messaging, ERP-style systems)',
        },
      ],
    },
    {
      image: '/platform.svg',
      titlePT: 'Dados, mensageria e infraestrutura',
      titleEN: 'Data, messaging & infra',
      descriptionPT:
        'Banco relacional ou documento, Prisma quando ajuda, Kafka ou Rabbit quando o fluxo é assíncrono. Docker para rodar igual em todo lugar; pipelines de CI/CD com GitHub Actions, qualidade medida no SonarCloud e operação na AWS ou no GCP conforme o time.',
      descriptionEN:
        'SQL or document store, Prisma when it fits, Kafka or Rabbit for async flows. Docker for parity across machines; CI/CD with GitHub Actions, quality gates via SonarCloud, and workloads on AWS or GCP depending on the team.',
      languagesTitlePT: 'Dados',
      languagesTitleEN: 'Data',
      languages: ['PostgreSQL', 'MongoDB', 'Prisma'],
      toolsTitlePT: 'Mensageria, nuvem e pipeline',
      toolsTitleEN: 'Messaging, cloud & pipeline',
      tools: [
        { pt: 'Kafka', en: 'Kafka' },
        { pt: 'RabbitMQ', en: 'RabbitMQ' },
        { pt: 'Docker', en: 'Docker' },
        { pt: 'CI/CD', en: 'CI/CD' },
        { pt: 'GitHub Actions', en: 'GitHub Actions' },
        { pt: 'SonarCloud', en: 'SonarCloud' },
        { pt: 'AWS', en: 'AWS' },
        { pt: 'GCP', en: 'GCP' },
      ],
    },
    {
      image: '/ai.svg',
      titlePT: 'Qualidade, testes e IA',
      titleEN: 'Quality, testing & AI',
      descriptionPT:
        'Testes automatizados (Jest, Vitest, Cypress quando precisa), revisão de PR com foco em bug e regressão. IA no dia a dia para repetir trabalho mecânico, explorar código e ler documentação maior com mais velocidade.',
      descriptionEN:
        'Automated tests (Jest, Vitest, Cypress when needed), PR review aimed at bugs and regressions. AI day-to-day for mechanical work, code exploration, and faster navigation of larger docs.',
      languagesTitlePT: 'Testes e qualidade',
      languagesTitleEN: 'Testing & quality',
      languages: ['Jest', 'Vitest', 'Cypress'],
      toolsTitlePT: 'IA aplicada à produtividade',
      toolsTitleEN: 'AI for productivity',
      tools: [
        { pt: 'Cursor', en: 'Cursor' },
        {
          pt: 'Claude Code (agente no terminal da Anthropic para editar código, rodar comandos e manter contexto do repositório)',
          en:
            'Claude Code (Anthropic terminal agent for code edits, commands, and repo-wide context)',
        },
        { pt: 'ChatGPT', en: 'ChatGPT' },
        {
          pt: 'Refatoração assistida e revisão de código',
          en: 'Assisted refactors & code review',
        },
        {
          pt: 'Pesquisa técnica e leitura de docs mais rápidas',
          en: 'Faster technical research and docs',
        },
      ],
    },
  ],
};

export default translations;
